// extracted by mini-css-extract-plugin
export var fileExt = "_v3-8";
export var fileIcon = "_v3-6";
export var fileLink = "_v3-5";
export var fileName = "_v3-7";
export var image = "_v3-1";
export var imageError = "_v3-3";
export var imageErrorIcon = "_v3-4";
export var imageLink = "_v3-0";
export var imageLoaded = "_v3-2";